<template src="./SvgIcon.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

const componentName = "SvgIconComponent";

export default defineComponent({
  name: componentName,
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
});
</script>
